import { ThunkType } from "../../../../../core/store/reducers";
import createClientBrokerApi from "../../api/clientBroker/createClientBroker";
import updateClientBrokerApi from "../../api/clientBroker/updateClientBroker";
import { setFetchStateBroker } from "../../clientsDataReducer";
import { ClientBroker } from "../../types";

export const upsertClientBroker = (broker: ClientBroker): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return;
	}

	dispatch(setFetchStateBroker({ type: "started" }));

	const { userId } = store.data.auth.current.user;
	const result = broker.cliBrokId
		? await dispatch(updateClientBrokerApi(userId, broker))
		: await dispatch(createClientBrokerApi(userId, broker));

	if (result && result.resCode === "OK") {
		dispatch(setFetchStateBroker({ type: "successful", result: result.resDesc }));
		return result.resDesc;
	} else {
		dispatch(setFetchStateBroker({ type: "error", errorCode: result?.resCode }));
	}
};
